import React, { useEffect } from "react";
import { AccordionItem, AccordionItemProps } from "@app/components/Drawer/AccordionItem";
import { initAccordionItems } from "@app/components/accordion-item";

interface AccordionProps {
  items: AccordionItemProps["item"][];
}

export const Accordion = ({ items }: AccordionProps) => {
  useEffect(() => {
    initAccordionItems();
  }, []);

  return (
    <div>
      {items.map((item, index) => (
        <AccordionItem key={index} item={item} />
      ))}
    </div>
  );
};
